import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cp-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent{

    constructor() { }

    @Input() widgetObject: any;
    @Input() widgetIndex: number = -1;
    @Input() loaderState: boolean = false;
    @Input() loaderErrorState: boolean = false;
    @Output() closeWidgetEvent = new EventEmitter<any>();
    @Output() expandWidgetEvent = new EventEmitter<any>();
    @Output() minimizeWidgetEvent = new EventEmitter<any>();
    @Output() fullScreenWidgetEvent = new EventEmitter<any>();
    @Output() nameEditedEvent = new EventEmitter<any>();
    @Output() isReorderable = new EventEmitter<any>();

    editState: boolean = false;

    menuItems: Array<any> = [{
        text: 'Full Screen',
        icon: 'expand',
        value: 1
    }, {
        text: 'Exit Full Screen',
        icon: 'compress',
        value: 2
    }, {
        text: 'Close',
        icon: 'times',
        value: 2
    }];

    closeWidget() {
        this.closeWidgetEvent.emit(this.widgetIndex);
    }

    expandWidget() {
        let newSize = this.widgetObject.size === 1 ? 2 : 1;
        this.expandWidgetEvent.emit({ index: this.widgetIndex, size: newSize });
        console.log('expandWidget 1');
    }

    minimizeWidget() {
        let newSize = this.widgetObject.minimized === 1 ? 2 : 1;
        this.minimizeWidgetEvent.emit({ index: this.widgetIndex, minimized: newSize });
    }

    fullScreenWidget() {
        let newSize = this.widgetObject.fullscreen === 1 ? 2 : 1;
        this.fullScreenWidgetEvent.emit({ index: this.widgetIndex, fullscreen: newSize });
    }

    toggleTitleEdit(state: boolean) {
        this.editState = state;
    }

    nameEdited() {
        this.nameEditedEvent.emit({ index: this.widgetIndex, title: this.widgetObject.widgetName });
    }

    public onEnter() {
        this.isReorderable.emit(false);
    }
    public onLeave() {
        this.isReorderable.emit(true);

    }
}
